import { AuthConfig } from "angular-oauth2-oidc";
export const authConfig: AuthConfig = {
  issuer: "",
  redirectUri: '',
  clientId: '',
  scope: 'openid profile email',
  requireHttps: true
}
